import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { VideoSearchActions } from './video-search.actions';
import { LoggerService } from '@app/core/infrastructure';

@Injectable()
export class VideoSearchEffects {
  private readonly actions$ = inject(Actions);
  private readonly logger = inject(LoggerService).scope('VideoSearchEffects');
  
  logSearchResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VideoSearchActions.handleSearchResults),
      tap(({ payload }) => {
        this.logger.debug('Received search results:', payload);
        
        payload.video_searches.forEach(search => {
          this.logger.debug(`Search query: "${search.query}", ${search.results.length} results`);
        });

        const totalResults = payload.video_searches.reduce(
          (total, search) => total + search.results.length, 
          0
        );
        this.logger.debug(`Total results: ${totalResults}`);
      })
    ),
    { dispatch: false }
  );

  logShowLink$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VideoSearchActions.showLink),
      tap(({ reason }) => {
        this.logger.debug('Showing video link', reason ? `- ${reason}` : '');
      })
    ),
    { dispatch: false }
  );

  logShowLinkAfterSpeech$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VideoSearchActions.showLinkAfterSpeech),
      tap(({ reason }) => {
        this.logger.debug('Showing video link after speech ends', reason ? `- ${reason}` : '');
      })
    ),
    { dispatch: false }
  );

  logHideLink$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VideoSearchActions.hideLink),
      tap(({ reason }) => {
        this.logger.debug('Hiding video link', reason ? `- ${reason}` : '');
      })
    ),
    { dispatch: false }
  );

  logClearResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VideoSearchActions.clearResults),
      tap(({ reason }) => {
        this.logger.debug('Clearing search results', reason ? `- ${reason}` : '');
      })
    ),
    { dispatch: false }
  );
}
